<template>
  <div class="layout">
    <!-- 左侧导航 -->
    <div class="menu">
      <Menu :isCollapse="isCollapse"></Menu>
    </div>
    <!-- 右侧内容 -->
    <div :class="isCollapse ? 'small' : 'content'">
      <div :title="isCollapse ? '点击展开' : '点击收起'" class="box_bgd" @click="isC">
        <!-- 点击展开收起导航和切换对应图标 -->
        <i
          :class="
            !isCollapse
              ? 'iconfont icon-shousuocaidan-copy'
              : 'iconfont icon-shousuocaidan'
          "
        ></i>
      </div>
      <Content></Content>
    </div>
  </div>
</template>
<script>
import Menu from "./menu/Index.vue";
import Content from "./content/Index.vue";
export default {
  components: {
    Menu,
    Content
  },
  data() {
    return {
      isCollapse: false
    };
  },
  created() {},
  methods: {
    isC() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>
<style lang="less" scoped>
.layout {
  // display: flex;
  .menu {
    // width: 200px;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    color: rgb(191, 203, 217);
    background: #304156;
    overflow-y: scroll;
  }
  .content {
    padding-left: 200px;
    height: 100vh;
  }
  .small {
    padding-left: 75px;
  }
}
.box_bgd {
  // width: 60px;
  // height: 60px;
  position: absolute;
  margin: 15px 5px 15px 10px;
  font-weight: bold;
  cursor: pointer;
}
.box_bgd i {
  font-size: 20px;
}
::-webkit-scrollbar {
  display: none;
}
</style>